import { render, staticRenderFns } from "./DefiMintSFTMConfirmation.vue?vue&type=template&id=3864f875&"
import script from "./DefiMintSFTMConfirmation.vue?vue&type=script&lang=js&"
export * from "./DefiMintSFTMConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports